import React, {useRef,useEffect} from 'react';
import mainStyles from 'components/homeParallax/HomeParallax.module.scss';
import styles from './Quote.module.scss'
import macroStyles from 'components/homePanels/f-i_macroPage/MacroPage.module.scss'
import Splitting from 'splitting';
import ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax} from "gsap";

const Quote = (props) => {

    const qouteLines = useRef();
    const quotee = useRef();
    const open = useRef();
    const close = useRef();
    const trigger = useRef();

    useEffect(()=>{

        let timeout = setTimeout(()=>{

            let controller = new ScrollMagic.Controller({
                container: props.scroller
            });

            let timeline = new TimelineMax();
            let elements = [];

            let quote1 = TweenMax.fromTo(open.current,{opacity: 0, left: -100}, { delay: 1, duration: 1, opacity: 1, left: 0});
            elements.push(quote1);

            const results = Splitting({ target: qouteLines.current, by: 'lines' });
            let time = 1;
            if(results && results[0]){
                results[0].lines.forEach((line)=>{
                    line.forEach((item)=>{
                        let line = TweenMax.fromTo(item,{opacity: 0, top: 50,}, { delay: time, opacity: 1, top: 0});
                        elements.push(line);
                    })
                    time = time + .2;
                })
            }

            let quote2 = TweenMax.fromTo(close.current,{opacity: 0, right: -100},{ delay: time, opacity: 1, right: 0});
            elements.push(quote2);

            let quoteTitle = TweenMax.fromTo(quotee.current,{opacity: 0, top: 50},{ delay: time+.2, opacity: 1, top: 0});
            elements.push(quoteTitle);

            timeline.add(elements);


            new ScrollMagic.Scene({
                reverse: true,
                triggerElement: trigger.current,
                triggerHook: 'onEnter',
                duration: '90%'})
                .setTween(elements)
                .addTo(controller);

            },300);

        return ()=>clearTimeout(timeout)

    },[props.scroller])

    return (

        <div ref={trigger} className={`${macroStyles.macroPanel} ${styles.quoteWrapper}`}>
            <p className={mainStyles.accessibleContent} dangerouslySetInnerHTML={{__html:props.quote + ' Quote by '+props.title}}></p>
            <p aria-hidden={true} className={styles.quote}>
                <span>
                    <span ref={open} className={styles.open}>“</span>
                    <span ref={qouteLines}  className={styles.quoteLines} dangerouslySetInnerHTML={{__html:props.quote}}/>
                    <span ref={close} className={styles.close}>”</span>
                </span>

            </p>
            <h5 aria-hidden={true} ref={quotee} className={styles.quotee}>- {props.title}</h5>
        </div>

    )
};

export default Quote
